import { Box, Skeleton, Stack } from "@mui/material";

/**
 * ServicesSkeleton — table rows matching the Services tab column widths.
 */
export function ServicesSkeleton(): React.ReactElement {
  const cardSx = {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "12px",
    p: 2.5,
    bgcolor: "background.paper",
  };

  return (
    <Box sx={cardSx}>
      {/* Header row */}
      <Stack
        direction="row"
        spacing={2}
        sx={{ pb: 1.5, borderBottom: "1px solid", borderColor: "divider" }}
      >
        <Skeleton variant="text" width={80} height={14} />
        <Skeleton variant="text" width={60} height={14} />
        <Skeleton variant="text" width={70} height={14} />
        <Skeleton variant="text" width={90} height={14} />
      </Stack>
      {/* Data rows */}
      {[1, 2, 3].map((i) => (
        <Stack
          key={i}
          direction="row"
          spacing={2}
          sx={{
            py: 1.5,
            borderBottom: i < 3 ? "1px solid" : "none",
            borderColor: "divider",
          }}
        >
          <Skeleton variant="text" width={80} height={16} />
          <Skeleton variant="text" width={60} height={16} />
          <Skeleton variant="rounded" width={70} height={20} />
          <Skeleton variant="text" width={90} height={16} />
        </Stack>
      ))}
    </Box>
  );
}

export default ServicesSkeleton;
